import React from "react";
import PropTypes from "prop-types";

/**
 * BounceTypeBadge Component
 * Displays bounce type as plain text
 * Used in the Inbox table when "Bounced" filter is active
 */
const BounceTypeBadge = ({ bounceType }) => {
  const getBounceConfig = () => {
    switch (bounceType) {
      case "HARD_BOUNCE":
        return {
          text: "Hard",
          ariaLabel: "Hard bounce"
        };
      case "SOFT_BOUNCE":
        return {
          text: "Soft",
          ariaLabel: "Soft bounce"
        };
      default:
        return {
          text: "--",
          ariaLabel: "No bounce type available"
        };
    }
  };

  const config = getBounceConfig();

  return (
    <div
      className="bounceTypeBadgeWrapper"
      aria-label={config.ariaLabel}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      }}
    >
      <span
        style={{
          fontSize: "14px",
          fontWeight: "400",
          color: "#6c757d",
          lineHeight: 1.2
        }}
      >
        {config.text}
      </span>
    </div>
  );
};

BounceTypeBadge.propTypes = {
  bounceType: PropTypes.oneOf(["HARD_BOUNCE", "SOFT_BOUNCE", null])
};

BounceTypeBadge.defaultProps = {
  bounceType: null
};

export default BounceTypeBadge;
